<template>
  <base-modal :modal-id="modalId" centered modal-size="lg">
    <template v-slot:header>
      <h4 class="modal-title mb-0 d-sm-none">{{ _T('Register') }}</h4>
      <h4 class="modal-title mb-0 d-none d-sm-block">
        {{ _T('Signup To') + ' ' }}
        {{ domainBasedBrand ? _T_DB(currentBrand, 'name') : _T('Go Order') }}
      </h4>
    </template>
    <template v-slot:modal-body>
      <div class="authentication">
        <div class="col-lg-12 p-0 full-height-row">
          <div class="signup-form">
            <div class="auth-right">
              <div
                class="d-flex d-lg-none mb-2"
                style="justify-content: space-between"
              >
                <h2>
                  {{ _T('Register') }}
                </h2>
                <a href="#" class="d-lg-none" @click="$bvModal.hide(modalId)"
                  ><svg width="14" height="14" fill="none">
                    <use xlink:href="#closeIcon"></use></svg
                ></a>
              </div>
              <div class="auth-bottom">
                <h6>{{ _T('Already have an account?') }}</h6>
                <button
                  class="btn btn-outline"
                  @click="proceedFurther('login')"
                >
                  {{ _T('Login') }}
                </button>
              </div>
              <div class="login-form">
                <!-- <h6>{{ _T('Enter your detail below') }}</h6> -->
                <form class="default-form row">
                  <div class="form-group col-lg-6">
                    <label>{{ _T('Full Name') }}</label>
                    <input
                      required
                      v-model="name"
                      type="text"
                      class="form-control"
                      value=""
                      :placeholder="_T('John')"
                      :class="{ 'border-danger': errors.name }"
                      autocomplete="new-password"
                    />
                    <span
                      v-if="errors.name"
                      class="validation-error d-block pt-1"
                    >
                      {{ errors.name }}
                    </span>
                  </div>
                  <div class="form-group col-lg-6">
                    <label>{{ _T('Phone Number') }}</label>
                    <div
                      :class="{
                        'border rounded border-danger': errors.phone_number,
                      }"
                    >
                      <vue-tel-input
                        v-model="phone_number"
                        @keypress.native="filterPhoneNumber($event)"
                        @change.native="sendSMSAgain"
                        :placeholder="_T('Phone number')"
                        v-bind="vueTelBindings"
                        :aria-readonly="readonly"
                        :smsSendSuccessfully="(readonly = true)"
                      ></vue-tel-input>
                    </div>
                    <span
                      v-if="errors.phone_number"
                      class="validation-error d-block pt-1"
                    >
                      {{ errors.phone_number }}
                    </span>

                    <span v-if="phone_number.length >= 10" class="">
                      <button
                        type="submit"
                        v-if="!otp_confirmed"
                        @click.prevent="genrateOTP()"
                        id="popover-button-event"
                        :disabled="checkSmsPassedValue"
                        v-b-modal.modal-sms
                        class="btn btn-solid btn-block"
                      >
                        {{ _T('Verify your phone number') }}
                      </button>
                    </span>
                    <b-modal
                      id="modal-sms"
                      centered
                      size="md"
                      hide-footer
                      :title="_T('Phone number confirmation')"
                      ok-only
                    >
                      <SMSConfirmation
                        :smsSent="smsSent"
                        :phone_number="phone_number"
                        v-on:checkSMS="checkSmsPassed"
                      ></SMSConfirmation>
                    </b-modal>
                  </div>
                  <!-- <div class="form-group col-lg-6 dsfsdf">
                            <SMSConfirmation
                              :smsSent="smsSent"
                              :phone_number="phone_number"
                              v-on:checkSMS="checkSmsPassed"
                            ></SMSConfirmation>
                          </div> -->
                  <div class="form-group col-lg-12">
                    <label>{{ _T('Email') }}</label>
                    <input
                      v-model="email"
                      required
                      type="email"
                      class="form-control"
                      :placeholder="_T('Email/Phone')"
                      :class="{ 'border-danger': errors.email }"
                      autocomplete="new-password"
                    />
                    <span
                      v-if="errors.email"
                      class="validation-error d-block pt-1"
                    >
                      {{ errors.email }}
                    </span>
                  </div>
                  <div class="form-group col-lg-6">
                    <label>{{ _T('Password') }}</label>
                    <div
                      class="input-group"
                      :class="
                        errors.password
                          ? 'border rounded border-danger'
                          : 'mb-3'
                      "
                    >
                      <input
                        required
                        v-model="password"
                        class="form-control"
                        :type="passwordFieldType"
                        :placeholder="_T('Enter your password')"
                        autocomplete="new-password"
                      />
                      <div class="input-group-append">
                        <span class="input-group-text"
                          ><img
                            src="/images/svg/account/eye.svg"
                            @click="switchPassVisibility"
                        /></span>
                      </div>
                    </div>
                    <span
                      v-if="errors.password"
                      class="validation-error d-block pt-1"
                    >
                      {{ errors.password }}
                    </span>
                  </div>
                  <div class="form-group col-lg-6">
                    <label>{{ _T('Confirm password') }}</label>
                    <div
                      class="input-group"
                      :class="
                        errors.password_repeat
                          ? 'border rounded border-danger'
                          : 'mb-3'
                      "
                    >
                      <input
                        required
                        v-model="password_repeat"
                        class="form-control"
                        :type="passwordFieldType2"
                        :placeholder="_T('Confirm your password')"
                        autocomplete="new-password"
                      />
                      <div class="input-group-append">
                        <span class="input-group-text"
                          ><img
                            src="/images/svg/account/eye.svg"
                            @click="switchPass2Visibility"
                        /></span>
                      </div>
                    </div>
                    <span
                      v-if="errors.password_repeat"
                      class="validation-error d-block pt-1"
                    >
                      {{ errors.password_repeat }}
                    </span>

                    <!-- <div class="remember">
                              <label class="d-none d-lg-inline-block">
                                <input
                                  required
                                  v-model="confirm_with_terms_of_use"
                                  class="checkbox_animated"
                                  type="checkbox"
                                />
                                {{ _T('I agree with Terms Of Use') }}
                              </label>
                            </div> -->
                  </div>

                  <div class="form-group col-lg-12">
                    <div
                      class="error alert fade show alert-danger mb-2"
                      v-if="errors.api_errors"
                    >
                      {{ errors.api_errors }}
                    </div>

                    <span v-if="checkSmsPassedValue">
                      {{ _T('Please enter your phone number') }}
                    </span>

                    <progress-bar
                      v-if="processInProgress(process)"
                      :btn-large="true"
                    />
                    <button
                      id="signup-button"
                      class="btn btn-solid btn-block"
                      v-else
                      @click.prevent="validateForm()"
                      :disabled="checkSmsPassedValue"
                    >
                      {{ _T('Sign Up') }}
                    </button>
                  </div>
                </form>
              </div>
              <div class="footer-signup">
                <h6>
                  {{ _T('By creating an account you agree to our') }}
                  <router-link :to="{ name: 'terms' }">
                    <span class="font-primary">{{
                      _T('Terms of Services')
                    }}</span>
                  </router-link>

                  {{ _T('and') }}
                  <router-link :to="{ name: 'privacy' }">
                    <span class="font-primary">{{ _T('Privacy Policy') }}</span>
                  </router-link>
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </base-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import SMSConfirmation from '../Blocks/SMSConfirmation'
import {
  validateEmail,
  validatePhoneNumber,
  handleApiErrors,
} from '@/utils/main_utils'
import { VueTelInput } from 'vue-tel-input'
import ProgressBar from '@/components/Elements/ProgressBar'
import ValidationMixin from '@/mixins/ValidationMixin'

import BaseModal from '@/components/Modals/BaseModal'

export default {
  name: 'Register',
  data() {
    return {
      name: '',
      phone_number: '',
      email: '',
      password: '',
      passwordFieldType: 'password',
      passwordFieldType2: 'password',
      password_repeat: '',
      // confirm_with_terms_of_use: false,
      errors: {},
      readonly: false,
      smsSent: false,
      inputFields: [],
      smsPassedPhone: null,
      process: 'register',
      modalId: 'signup',
      vueTelBindings: {
        mode: 'international',
        disabledFormatting: true,
        enabledCountryCode: true,
        dropdownOptions: {
          disabledDialCode: false,
          showDialCodeInSelection: true,
        },
        inputOptions: {
          showDialCode: false,
        },
      },
      smsSentSuccessfully: false,
      mobileConfirmedSuccessfully: false,
    }
  },
  watch: {
    name(newVal, oldVal) {
      if (newVal != oldVal) {
        if (newVal.trim().length >= 2) {
          this.errors.name = ''
        } else {
          this.errors.name = this._T('Name should be at least 2 characters')
          this.errors.count = 1
        }
      }
    },
    email(newVal, oldVal) {
      if (newVal != oldVal) {
        if (validateEmail(newVal)) {
          this.errors.email = ''
        } else {
          this.errors.email = this._T('Invalid Email format')
          this.errors.count = 1
        }
      }
    },
    phone_number(newVal, oldVal) {
      if (newVal != oldVal) {
        if (validatePhoneNumber(newVal)) {
          this.errors.phone_number = ''
        } else {
          this.errors.phone_number = this._T('Invalid phone number')
          this.errors.count = 1
        }
      }
    },
    password(newVal, oldVal) {
      if (newVal != oldVal) {
        if (newVal.trim().length >= 2) {
          this.errors.password = ''
        } else {
          this.errors.password = this._T(
            'Password should be at least 2 characters'
          )
          this.errors.count = 1
        }
      }
    },
    password_repeat(newVal, oldVal) {
      if (newVal != oldVal) {
        if (newVal.trim().length >= 2) {
          this.errors.password_repeat = ''
        } else {
          this.errors.password_repeat = this._T(
            'Password should be at least 2 characters'
          )
          this.errors.count = 1
        }
      }
    },
  },
  computed: {
    ...mapGetters([
      'login_success_message',
      'login_fail_message',
      'login_in_progress',
      '_T',
      'processInProgress',
      'otp_progress_fail',
      'otp_verification',
      'otp_confirmed',
      'domainBasedBrand',
      '_T_DB',
      'currentBrand',
    ]),
    checkSmsPassedValue() {
      return false
      // eslint-disable-next-line no-unreachable
      if (
        validatePhoneNumber(this.phone_number) &&
        !(this.smsPassedPhone === this.phone_number)
      ) {
        return true
      }
      return false
    },
  },
  mixins: [ValidationMixin],
  components: {
    SMSConfirmation,
    VueTelInput,
    ProgressBar,
    BaseModal,
  },
  methods: {
    sendSMSAgain() {
      this.smsSent = false
      this.smsSentSuccessfully = false
      this.mobileConfirmedSuccessfully = false
      this.$store.commit('RESET_OTP_PROGRESS')
    },
    proceedFurther(modalToShow) {
      this.$bvModal.hide('signup')
      this.$bvModal.show(modalToShow)
    },
    switchPassVisibility() {
      this.passwordFieldType =
        this.passwordFieldType === 'password' ? 'text' : 'password'
    },
    switchPass2Visibility() {
      this.passwordFieldType2 =
        this.passwordFieldType2 === 'password' ? 'text' : 'password'
    },
    validateForm() {
      this.errors = {}
      this.errors.count = 0
      if (this.name.trim().length < 2) {
        this.errors.name = this._T('Name should be at least 2 characters')
        this.errors.count = 1
      }
      if (!validateEmail(this.email)) {
        this.errors.email = this._T('Invalid Email format')
        this.errors.count = 1
      }

      if (!validatePhoneNumber(this.phone_number)) {
        this.errors.phone_number = this._T('Invalid phone number')
        this.errors.count = 1
      }

      if (!this.otp_confirmed) {
        this.errors.phone_number = this._T('Mobile number needs to be verified')
        this.errors.count = 2
      }

      if (this.password.trim() < 2) {
        this.errors.password = this._T(
          'Password should be at least 2 characters'
        )
        this.errors.count = 1
      }
      if (this.password_repeat.trim() < 2) {
        this.errors.password_repeat = this._T(
          'Password should be at least 2 characters'
        )
        this.errors.count = 1
      }
      if (
        this.password_repeat.trim() &&
        this.password.trim() != this.password_repeat.trim()
      ) {
        this.errors.password_repeat = this._T('Passwords should match')
        this.errors.count = 1
      }
      if (this.errors.count === 0) {
        this.register()
      } else {
        return
      }
    },
    register() {
      if (!this.processInProgress(this.process)) {
        this.$store.dispatch('startProcess', {
          process: this.process,
          progress: true,
        })
        this.errors = []
        this.$store
          .dispatch('register', {
            name: this.name,
            email: this.email.toString().toLowerCase(),
            password: this.password,
            phone_number: this.phone_number,
          })
          .then((response) => {
            if (response.data.status == 'form_errors') {
              this.errors.api_errors = handleApiErrors(
                response.data.form_errors
              )
            } else {
              this.$router.push('personal-info')
              this.$bvModal.hide(this.modalId)
            }
            //reset guest checkout
            this.$store.commit('SET_GUEST_CHECKOUT', false)
            this.$store.commit('SET_GUEST_INFO', {})
          })
          .finally(() => {
            this.$store.dispatch('stopProcess', this.process)
          })
      }
    },
    checkSmsPassed() {
      this.smsPassedPhone = this.phone_number
    },
    genrateOTP() {
      var that = this
      that.inputFields.forEach((e, i) => {
        that.inputFields[i] = ''
      })
      let phoneNumber = this.phone_number
      phoneNumber = phoneNumber.replace(/[+]|\s/gi, '')
      this.$store
        .dispatch('sendOTP', {
          mode: 'mobile',
          reference: phoneNumber,
        })
        .then((resp) => {
          let responseData = resp.data
          if (responseData.status === 'form_errors') {
            let errors = handleApiErrors(responseData.form_errors)
            this.$store.dispatch('showNotification', {
              text: this._T(errors),
              status: 'error',
            })
          } else {
            that.smsSent = true
            that.smsSentSuccessfully = true
            this.$store.commit('SET_OTP_SENT')
          }
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.authentication {
  background-color: $white !important;
  overflow: -moz-scrollbars-none;
  -ms-overflow-style: none;
  ::-webkit-scrollbar {
    width: 0 !important;
  }
  .full-height-row {
    @media (max-width: 575px) {
      height: 100%;
    }
  }
  .signup-form {
    // height: 100vh;
    height: unset !important;
    overflow-x: hidden;
    overflow-y: auto;
    @media (max-width: 575px) {
      margin-top: 2rem;
      margin-bottom: 8rem;
    }
  }
  .auth-left {
    background-image: url('/images/login-bg.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;
    height: 100vh;
    position: absolute;
    img {
      position: absolute;
      left: 8.33%;
      top: 5.67%;
    }
  }
  .login-logo {
    text-align: center;
    display: none;
  }
  .auth-right {
    display: block;
    // align-items: center;
    height: 100%;
    width: 100%;
    position: relative;
    a {
      font-weight: 500;
    }
    .login-form {
      // width: $px500;
      width: auto;
      margin: auto;
      .default-form {
        @media (max-width: 575px) {
          margin-bottom: 2rem;
          .form-group {
            #signup-button {
              padding: 0 !important;
              height: $px40;
            }
          }
        }
        &::-webkit-scrollbar {
          display: none;
        }
      }
      .confirm-phone-link {
        position: absolute;
        display: block;
        right: $px20;
        button {
          background-color: $white;
          color: $fb-bg;
          padding: 0;
          border: none;
          @media (max-width: 575px) {
            font-size: 12px;
            text-transform: unset;
          }
          &:hover {
            text-decoration: underline;
          }
        }
      }
      .header-mobile {
        display: none;
      }
      h2 {
        color: $font-color;
        text-transform: capitalize;
        margin-bottom: $px20;
      }
      h6 {
        line-height: $px22;
        letter-spacing: 0.5px;
        color: $font-color;
        margin-bottom: calc(
          #{$px20} + (33 - 20) * ((100vw - #{$px320}) / (1920 - 320))
        );
      }
      .remember {
        padding-bottom: $px5;
        label {
          color: $light-font;
          font-weight: 500;
          margin-bottom: 0;
        }
        a {
          float: right;
        }
      }
      .divider {
        padding-top: $px24;
        position: relative;
        clear: both;
        height: 0;
        margin: $px33 0 $px9;
        border-top: 1px solid $light-border;
        &::before {
          position: absolute;
          top: -$px11;
          left: 47%;
          font-size: $px13;
          line-height: $px22;
          letter-spacing: 0.5px;
          margin-left: -$px10;
          padding: 0 $px10;
          content: 'OR';
          color: $light-font;
          background: $white;
        }
      }
      .btn {
        position: relative;
        text-transform: capitalize;
        i,
        img {
          position: absolute;
          font-size: $px22;
          top: 26%;
          left: 5%;
        }
        &.btn-google {
          margin-top: 0;
          margin-left: $px15;
          background: $light-border;
        }
      }
    }
    .auth-bottom {
      text-align: right;
      padding: 0;
      // padding: calc(#{$px25} + (50 - 25) * ((100vw - #{$px320}) / (1920 - 320)))
      //   0 calc(#{$px20} + (50 - 20) * ((100vw - #{$px320}) / (1920 - 320)));
      h6 {
        font-weight: 300;
        letter-spacing: 0.5px;
        color: $font-color;
        display: inline-block;
        margin-right: $px10;
      }
    }
  }
  .button-group {
    align-items: center;
  }
}
#modal-sms {
  .modal-header {
    .close {
      color: $color-primary;
      opacity: 1;
    }
  }
}
.footer-signup {
  padding: $px17;
  text-align: center;
  border-top: $px1 solid $light-border;
  h6 {
    margin-bottom: 0;
    line-height: $px17;
    letter-spacing: 0.02em;
    color: $light-font;
    font-weight: 500;
  }
}
@media (max-width: 1199px) {
  .authentication {
    .auth-right {
      .login-form {
        .divider {
          margin: $px15 0 -$px8;
        }
      }
    }
  }
}
@media (max-width: 991px) {
  .authentication {
    position: fixed;
    // max-height: 80vh;
    display: flex;
    align-items: center;
    justify-content: center;
    // width: 100vw;
    left: 0;
    top: 0;
    overflow-y: auto;
    .signup-form {
      // max-height: 80vh;
      overflow-x: unset;
    }
    > .row {
      width: 90vw;
    }
    .auth-left {
      display: none;
    }
    .login-logo {
      margin: calc(#{$px20} + (40 - 20) * ((100vw - #{$px320}) / (1920 - 320)))
        0 calc(#{$px30} + (92 - 30) * ((100vw - #{$px320}) / (1920 - 320)));
      display: block;
    }
    .auth-right {
      align-items: unset;
      height: auto;
      padding: 0 $px20;
      > div {
        width: 100%;
      }
      .login-form {
        width: 100%;
        .remember {
          margin-bottom: $px55;
        }
        h2 {
          margin-bottom: $px14;
        }
        .divider {
          margin: $px16 0 -$px6;
        }
      }
      .auth-bottom {
        position: relative;
        right: unset;
        text-align: left;
        top: unset;
        // margin-top: $px45;
        h6 {
          font-weight: 600;
          font-size: $px12 !important;
          line-height: $px17;
          text-align: center;
          letter-spacing: 0.02em;
          margin-right: $px5 !important;
        }
        .btn {
          margin-top: unset !important;
        }
      }
      .login-form {
        .btn {
          i,
          img {
            left: 10%;
          }
        }
      }
    }
  }
}
@media (width: 640px) and (height: 360px) {
  .authentication {
    align-items: flex-start;
  }
}
@media (max-width: 575px) {
  .authentication {
    padding: 1.5rem !important;
    > .row {
      width: 100vw;
    }
    .p-0 {
      padding: 0 $px15 !important;
    }
    .auth-right {
      padding: 0;
      overflow-x: hidden;
      .login-form {
        width: auto;
      }
    }
    &.sign-up {
      align-items: flex-start;
    }
  }
  .footer-signup {
    h6 {
      padding: 0 $px10;
    }
  }
}
@media (max-width: 360px) {
  .authentication {
    align-items: flex-start;
    .auth-right {
      .login-form {
        .btn {
          padding: 0.5rem 0 0.9375rem 0;
        }
      }
    }
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .authentication {
    .signup-form {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
.body-rtl {
  // @media (max-width: 575px) {
  .default-form {
    .form-group {
      .input-group {
        input {
          border-left: none;
          border-right: 1px #edeff4 solid;
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
          border-top-right-radius: 0.375rem;
          border-bottom-right-radius: 0.375rem;
        }
        .input-group-append {
          .input-group-text {
            border-right: none;
            border-left: 1px #edeff4 solid;
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
            margin-left: 1px;
            border-bottom-left-radius: 5px;
            border-top-left-radius: 5px;
          }
        }
      }
    }
  }
  .authentication {
    .vue-tel-input {
      align-items: stretch;
      width: 100%;
      input {
        // text-align: right;
      }
    }
    .auth-right {
      .login-form {
        h6 {
          text-align: right;
        }
        .remember {
          a {
            float: left;
          }
        }
      }
    }
  }
  .footer-signup {
    a {
      span {
        float: unset;
      }
    }
  }
}
</style>
